import { getAreaCode, getConfig } from '@/services/js_sdk';
import { setAreaCode } from '@/utils/utils';
import wx from 'wx';

export const updateUserLocation = ({success}) => {
  wx.getLocation({
    type: "wgs84",
    success: (res) => {
      if (res.errMsg === "getLocation:ok") {
        getAreaCode({
          lat: res.latitude,
          lng: res.longitude,
        }).then(response => {
          if (response.code === 200) {
            const areaCode = response.data.ad_info.adcode;
            setAreaCode(areaCode);
            if (typeof success === 'function') {
              success(areaCode);
            }
          }
        }).catch(() => {
        })
      }
    }
  })
}
